import PdfIframeViewer from "./PdfIframeViewer";
import "./PdfVViewer.css";

/**
 * ورود اصلی نمایشگر PDF — در aryazar هم حالت iframe و هم react-pdf-viewer بود؛
 * اینجا فقط iframe تا بدون وابستگی اضافی بماند.
 */
export default function PdfVViewer({ fileUrl, downloadFileName = "gozaresh-list-asnad.pdf" }) {
  if (!fileUrl || !String(fileUrl).trim()) {
    return (
      <div className="pdf-viewer-reset flex h-full min-h-[320px] w-full flex-col rounded-md border bg-white">
        <div className="pdf-viewer-body flex flex-1 items-center justify-center p-8 text-center text-muted-foreground">
          آدرس معتبر PDF مشخص نشده است.
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-viewer-reset flex h-full min-h-0 w-full flex-col rounded-md border bg-white">
      <div className="pdf-viewer-body flex min-h-0 flex-1 flex-col overflow-hidden">
        <PdfIframeViewer fileUrl={fileUrl} downloadFileName={downloadFileName} />
      </div>
    </div>
  );
}
